import React from 'react';
import { Badge } from './Badge';
import { CategoryModel, Language } from 'ts-core';
import { Link } from 'react-router-dom';

interface CategoryBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  category: CategoryModel;
  language: Language;
  inverted?: boolean;
  href?: string;
}

export function CategoryBadge(props: CategoryBadgeProps) {
  const { inverted, category, language, href, ...rest } = props;

  const badge = (
    <Badge color={inverted ? 'white' : category.color} {...rest}>
      <span
        style={{
          color: inverted ? category.color : 'white',
        }}
        className="whitespace-nowrap drop-shadow-lg font-bold"
      >
        {category.displayName.getText(language)}
        <span
          style={{
            fontFamily: 'fontAwesome',
            marginLeft: 5,
            display: 'inline-block',
            color: inverted ? category.color : 'white',
          }}
        >
          {category.icon}
        </span>
      </span>
    </Badge>
  );

  if (href) {
    return (
      <Link to={href} className="no-underline text-current" style={{ textDecoration: 'none' }}>
        {badge}
      </Link>
    );
  }
  return badge;
}
